import { render, staticRenderFns } from "./DoctorLounge.vue?vue&type=template&id=ab4bc1f0&"
import script from "./DoctorLounge.vue?vue&type=script&lang=js&"
export * from "./DoctorLounge.vue?vue&type=script&lang=js&"
import style0 from "./DoctorLounge.vue?vue&type=style&index=0&id=ab4bc1f0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports